import { Card, CardTitle, Divider, Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const ParcelPreparePageSkeleton = () => {
  return (
    <Styles.Container>
      <Styles.Header>
        <Styles.NavRow>
          <Skeleton variant="rounded" width={140} height={20} />
          <Styles.NavContainer>
            <Skeleton variant="rounded" width={70} height={20} />
            <Skeleton variant="rounded" width={50} height={20} />
          </Styles.NavContainer>
        </Styles.NavRow>
        <Styles.HeaderOptions>
          <Styles.HeaderOptionsLeft>
            <Skeleton variant="text" width={180} height={28} />
            <Skeleton variant="rounded" width={80} height={24} />
            <Skeleton variant="rounded" width={100} height={24} />
          </Styles.HeaderOptionsLeft>
          <Styles.HeaderActions>
            <Skeleton variant="rounded" width={120} height={32} />
          </Styles.HeaderActions>
        </Styles.HeaderOptions>
      </Styles.Header>

      <Styles.MainContainer>
        <Card showBorder={false}>
          <CardTitle>
            <Skeleton variant="text" width={180} height={24} />
          </CardTitle>
          <Styles.CardContent>
            <Skeleton variant="text" width="80%" height={20} />
            <Skeleton variant="rounded" width="100%" height={40} />
            <Divider />
            <Styles.ItemsContainer>
              {Array.from({ length: 4 }).map((_, index) => (
                <Styles.LineItem key={index}>
                  <Skeleton variant="rounded" width={64} height={64} />
                  <Styles.ProductInfo>
                    <Skeleton variant="text" width={180} height={20} />
                    <Skeleton variant="text" width={100} height={14} />
                    <Skeleton variant="rounded" width={80} height={20} />
                  </Styles.ProductInfo>
                  <Skeleton variant="rounded" width={60} height={32} />
                  <Skeleton variant="rounded" width={24} height={24} />
                </Styles.LineItem>
              ))}
            </Styles.ItemsContainer>
            <Divider />
            <Styles.SummaryRow>
              <Skeleton variant="text" width={120} height={16} />
              <Skeleton variant="rounded" width={60} height={16} />
            </Styles.SummaryRow>
            <Styles.SummaryRow>
              <Skeleton variant="text" width={140} height={16} />
              <Skeleton variant="rounded" width={60} height={16} />
            </Styles.SummaryRow>
          </Styles.CardContent>
        </Card>

        <div>
          <Card showBorder={false}>
            <CardTitle>
              <Skeleton variant="text" width={100} height={24} />
            </CardTitle>
            <Styles.CardContent>
              <Styles.SummaryRow>
                <Skeleton variant="text" width={120} height={16} />
                <Skeleton variant="rounded" width={60} height={16} />
              </Styles.SummaryRow>
              <Styles.SummaryRow>
                <Skeleton variant="text" width={140} height={16} />
                <Skeleton variant="rounded" width={60} height={16} />
              </Styles.SummaryRow>
              <Divider />
              <Skeleton variant="text" width={100} height={20} />
              <Skeleton variant="rounded" width="100%" height={40} />
              <Skeleton variant="text" width={80} height={20} />
              <Skeleton variant="rounded" width="100%" height={80} />
              <Divider />
              <Skeleton variant="text" width={120} height={20} />
              <Skeleton variant="text" width="80%" height={16} />
              <Styles.DocumentLine>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width={160} height={16} />
              </Styles.DocumentLine>
              <Styles.ActionsContainer>
                <Skeleton variant="rounded" width="100%" height={40} />
                <Skeleton variant="rounded" width="100%" height={40} />
              </Styles.ActionsContainer>
            </Styles.CardContent>
          </Card>
        </div>
      </Styles.MainContainer>
    </Styles.Container>
  )
}

export default ParcelPreparePageSkeleton
